import { MtxButton, MtxProgressbar } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import { FamilleCardReprendreSouscription } from '@/components/Dico';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';
import { useUserStore } from '@/store/useStore';

import styles from './styles.module.css';

type Props = {
  completed: number;
  famille: string | null | undefined;

  NomContratCard?: string | null | undefined;
  lienDeReprise?: string;
  dateDebutSouscription: string;
  token?: string;
  headerName?: string;
};

const CardResumeSubscription = ({
  famille,
  completed,
  NomContratCard,
  lienDeReprise,
  dateDebutSouscription,
  token,
  headerName,
}: Props) => {
  const { t } = useTranslation();
  const dateOuverture = dateDebutSouscription.split('-').reverse().join('/');
  const userConseiller = useUserStore((state) => state.user);

  return (
    <div className={styles.contentCardResumeSubscription}>
      <div className={styles.familyCardResumeSubscription}>
        {FamilleCardReprendreSouscription[famille as keyof typeof FamilleCardReprendreSouscription] ?? (
          <span className={styles.withoutFamily}>{t('cardResumeSubscription.fallbackFamille')}</span>
        )}
      </div>
      <div className={styles.infoCardSubscription}>
        <p className={styles.colorInfoSubscription}>
          {t('cardResumeSubscription.startedOn')} {dateOuverture} -{' '}
          {!famille ? (
            <>
              {t('cardResumeSubscription.awaitingProfile')}{' '}
              <span className={styles.secondColorDescription}>
                {t('cardResumeSubscription.awaitingProfileHighlight')}
              </span>
            </>
          ) : (
            <>
              {t('cardResumeSubscription.forContract')}{' '}
              <span className={styles.secondColorDescription}>{NomContratCard}</span>.
            </>
          )}
        </p>
      </div>
      <div className={styles.contentProgressBar}>
        <MtxProgressbar value={completed} size="medium" />
        <div className={styles.cardSubscriptionButton}>
          <MtxButton
            onClick={() => {
              window.open(
                `${lienDeReprise}${headerName}=${token}&at_campaign=espace_client&at_identifier=placement_interne&origine=42`
              );
              void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
                event_id: 'clic',
                event_categorie: 'clic',
                event_metier: 'espace client placement',
                event_nom: 'reprendre ma souscription',
                event_detail_1: 'cta',
                event_detail_2: ` ${famille} - ${NomContratCard} `,
              });
            }}
            variant="tertiary"
            size="small"
            full-width="true"
            disabled={userConseiller?.advisorView === true}
          >
            <div>{t('cardResumeSubscription.resumeButton')}</div>
          </MtxButton>
        </div>
      </div>
    </div>
  );
};

export default CardResumeSubscription;
